import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GatherBaseComponent } from './gather-base/gather-base.component';
import { GatherLandingPageComponent } from './gather-landing-page/gather-landing-page.component';
import { AvailabilityComponent } from './availability/availability.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { GatherNotInterestedComponent } from './gather-not-interested/gather-not-interested.component';
import { GatherInvalidUuidComponent } from './gather-invalid-uuid/gather-invalid-uuid.component';
import { AlreadyATalentComponent } from "./already-a-talent/already-a-talent.component";
import { EeocFormComponent } from "../eeoc/eeoc-form/eeoc-form.component";
import { JobClosedComponent } from "./job-closed/job-closed.component";
import { AnswerPreInterviewQuestionsComponent } from "../pre-interview-questions/answer-pre-interview-questions/answer-pre-interview-questions.component";

const routes: Routes = [
  {
    path: ':trackingId',
    component: GatherBaseComponent,
    children: [
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full'
      },
      {
        path: 'main',
        component: GatherLandingPageComponent
      },
      {
        path: 'availability',
        component: AvailabilityComponent
      },
      {
        path: 'confirm',
        component: ConfirmComponent
      },
      {
        path: 'not-interested',
        component: GatherNotInterestedComponent
      },
      {
        path: 'invalid-id',
        component: GatherInvalidUuidComponent
      },
      {
        path: 'already-a-talent',
        component: AlreadyATalentComponent
      },
      {
        path: 'eeoc-form',
        component: EeocFormComponent
      },
      {
        path: 'job-closed',
        component: JobClosedComponent
      },
      {
        path: 'pre-interview-questions',
        component: AnswerPreInterviewQuestionsComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GatherRoutingModule {}
